import { z } from 'zod'
import { listResourceSchema } from '@/types/schema/api/list-resource-schema'

export type FetchHashtagInfiniteRequest = { page: number; per_page: number }

const hashtagReportSchema = z.object({
  created_at: z.string().datetime(),
  /** 代表hashtag 的唯一值 */
  hash: z.string(),
  hashtag: z.string(),
})

export type HashtagReport = z.infer<typeof hashtagReportSchema>

export const hashtagReportListResponseSchema = listResourceSchema.extend({
  data: hashtagReportSchema.array(),
})

export type HashtagReportListResponse = z.infer<
  typeof hashtagReportListResponseSchema
>
